module.exports = __webpack_public_path__ + "static/a-xx-008-art-eef585a41daa16ca069d0307449ac0c1.jpg";